// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
export const isEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.toLowerCase());
};

export const isProjectNameValid = (projectName: string) => {
  //eslint-disable-next-line no-control-regex
  const pattern = /^[^<>:"/\\|?*\x00-\x1F]+$/;
  return pattern.test(projectName);
};
